/**
 * Copyright since 2007 PrestaShop SA and Contributors
 * PrestaShop is an International Registered Trademark & Property of PrestaShop SA
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License version 3.0
 * that is bundled with this package in the file LICENSE.md.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * @author    PrestaShop SA and Contributors <contact@prestashop.com>
 * @copyright Since 2007 PrestaShop SA and Contributors
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License version 3.0
 */
export class CustomizationHandler {
    init() {
        let action = $('#product_customization_id').val() ? 'createCustomization' : 'editCustomization';
        this.handleAddToCart(action);
    }

    parseDateFromString(dateStr) {
        if (!dateStr) return null;
        let parts = dateStr.split('/');
        if (parts.length < 3) return null;
        let day = parseInt(parts[0], 10);
        let month = parseInt(parts[1], 10) - 1;
        let year = parts[2];
        // Si year au format 'yy', on suppose 2000+
        if (year.length === 2) {
            year = 2000 + parseInt(year, 10);
        } else {
            year = parseInt(year, 10);
        }
        return new Date(year, month, day);
    }

    handleAddToCart(action) {
        let self = this;
        $('body').on('click', '.custom-add-to-cart', function(e) {
            if (self.parseDateFromString($('#startDate').val())) {
                $.ajax({
                    type: 'POST',
                    headers: {"cache-control": "no-cache"},
                    url: prestashop.urls.base_url + '?rand=' + new Date().getTime(),
                    async: true,
                    cache: false,
                    dataType: 'json',
                    data: {
                        fc: 'module',
                        module: 'velocation',
                        action: action,
                        controller: 'CustomizationHandler',
                        id_product: $('#product_page_product_id').val(),
                        id_product_attribute: $('#product_page_product_id_attribute').val() || 0,
                        id_customization: $('#product_customization_id').val() || 0,
                        quantity: $('#quantity_wanted').val() || 1,
                        dateFrom: $('#startDate').val(),
                        token: prestashop.static_token,
                        ajax: 1,
                    },
                    success: function (data) {
                        if (data.success && data.id_customization) {
                            $('#product_customization_id').val(data.id_customization);

                            setTimeout(() => {
                                $('#add-to-cart-btn').trigger('click');
                            }, 200);

                            // On remet la quantité choisie après l'ajout au panier
                            $('#endDateContainer span.text-danger').text(chooseDate);
                            $('#startDate').val('');
                        }
                    }
                });
            }
        });
    }
};